export const areDeepEqual = (firstElement: any, secondElement: any): boolean =>
  JSON.stringify(firstElement) === JSON.stringify(secondElement);
